import React, { useState } from "react";
import {
  Card,
  Typography,
  CardActionArea,
  Box,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";


import TestMaster from "../../HospitalPages/Radiology/TestMaster";
import TestRequest from "../../HospitalPages/Radiology/TestRequest";
import SampleCollectionReoprtEntry from "../../HospitalPages/Radiology/SampleCollectionReoprtEntry";
import UploadPrintReports from "../../HospitalPages/Radiology/UploadPrintReports";
import LabBilling from "../../HospitalPages/Radiology/LabBilling";
import RadiologyLabReports from "../../HospitalPages/Radiology/RadiologyLabReports";
import DashboardCards from "../HospitalDashBoardCards";
import { decrypt } from "../../components/cryptoUtil";
import { includeCardForRoles, ROLES } from "../componenet/heading";


const RadiologyDashBoard = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
const tokenData = localStorage.getItem("tokenData");
    const decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
    const userName = decryptedData.userfullname || "";
const userRole = decryptedData.userrole || "";

const cardRoles = {
  "Test Master": [ROLES.RECEPTIONIST], // only userRole 101 can see
  "Test Requests": [ROLES.RECEPTIONIST],   // only userRole 102 can see
  "Sample Collection / Report Entry": [ROLES.RECEPTIONIST],
  "Upload & Print Reports (PDF/Images)": [ROLES.STAFF],
  "Lab Billing": [ROLES.ACCOUNTSECTION],
  "Radiology & Lab Reports": [ROLES.DOCTOR,ROLES.RECEPTIONIST],
};

  const cards = [
     ...includeCardForRoles(cardRoles["Test Master"], userRole,{
      title: "Test Master",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🏥</span> : null,
      component: <TestMaster />,category: "👨‍⚕️ Radiology Data Management",
    }),
     ...includeCardForRoles(cardRoles["Test Requests"], userRole,{
      title: "Test Requests",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🛌</span> : null,
      component: <TestRequest />,category: "👨‍⚕️ Radiology Data Management",
    }),
   
     ...includeCardForRoles(cardRoles["Sample Collection / Report Entry"], userRole,{
      title: "Sample Collection / Report Entry",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>✔️</span> : null,
      component: <SampleCollectionReoprtEntry />,category: "👨‍⚕️ Radiology Data Management",
    }),
     ...includeCardForRoles(cardRoles["Upload & Print Reports (PDF/Images)"], userRole,{
      title: "Upload & Print Reports (PDF/Images)",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <UploadPrintReports />,category: "👨‍⚕️ Radiology Data Management",
    }),

      ...includeCardForRoles(cardRoles["Lab Billing"], userRole,{
      title: "Lab Billing",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <LabBilling />,category: "👨‍⚕️ Radiology Data Management",
    }),

     ...includeCardForRoles(cardRoles["Radiology & Lab Reports"], userRole,{
      title: "Radiology & Lab Reports",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <RadiologyLabReports /> ,category: "👨‍⚕️ Radiology Data Management",
    }),

  ];
//👨‍⚕️ Radiology Data Management
 
  
     return (
      <DashboardCards
        cards={cards}
        menulabel={1}
        welcomeMessage={
          <Typography variant="h5" align="center" gutterBottom>
           👨‍⚕️ Radiology Data Management
          </Typography>
        }
      />
    );
  };
  
export default RadiologyDashBoard;
